import * as React from "react";
import { List, DataTable, SearchInput, NumberField } from "react-admin";

const PlanFilter = [<SearchInput source="name" alwaysOn />];

const PlanList = () => (
  <List title="Planes Usuarios" filters={PlanFilter}>
    <DataTable bulkActionButtons={false}>
      <DataTable.Col source="name" label="Nombre" />
      <DataTable.Col source="description" label="Descripción" />
      <DataTable.Col source="discount" label="Descuento">
        <NumberField
          source="discount"
          label="Descuento"
          options={{ style: "percent", maximumFractionDigits: 2 }}
        />
      </DataTable.Col>
      <DataTable.Col source="price" label="Precio">
        <NumberField
          source="price"
          label="Precio"
          options={{ style: "currency", currency: "ARS" }}
        />
      </DataTable.Col>
      {/* <EditButton /> */}
    </DataTable>
  </List>
);

export default PlanList;
